import React, { useState, useEffect } from 'react';
import { Form, Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthInfo from '../../components/AuthInfo/AuthInfo';
import AuthForm from '../../components/AuthForm/AuthForm';
import PasswordField from '../../components/SharedComponents/FormComponents/PasswordField';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import { toastNotify } from '../../utils/toastNotify';
import './ForgotPassword.scss';
import { realBricksApi } from '../../utils/axiosInterceptors';
import { AES } from 'crypto-js'

const NewPassword = () => {
  const [viewForm, setViewForm] = useState(false);
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');

  useEffect(() => {
    if (token) {
      localStorage.setItem('access_token_temp', token);
      window.history.replaceState(null, '/forgot-password/new-password', '/forgot-password/new-password');
    }
  }, []);

  const onFinish = async (values) => {
    if (values.password === values.newPassword) {
      setLoading(true);
      let formData = {
        newPassword: AES.encrypt(values.newPassword,process.env.REACT_APP_PASSWORD_ENCRYPT_KEY).toString(),
      };
      try {
        const resData = await realBricksApi.put(`/api/v1/user/password`, formData);
        if (!resData.isError) {
          navigate('/forgot-password/allset');
          setLoading(false);
        } else {
          setLoading(false);
          toastNotify('error', resData?.message);
          // setWrongEmailError(true)
        }
      } catch (error) {
        // setWrongEmailError(true)
        setLoading(false);
        toastNotify('error', error?.response?.data?.message);
      }
    } else {
      toastNotify('error', 'The two passwords that you entered do not match.');
    }
  };

  return (
    <div className='auth auth--details auth--no-info-mobile login'>
      <AuthInfo
        className={viewForm ? 'hide' : null}
        title={<>Welcome back</>}
        description={<>Enter your credentials to access your Realbricks account.</>}
      >
        <div className='mobile-action' onClick={() => setViewForm(true)}>
          <Button className='w-100'>Get Started</Button>
        </div>
      </AuthInfo>
      <AuthForm
        className={viewForm ? 'show' : null}
        title={<>Create a new password</>}
        description={<>Saving a new password will sign you out on all your devices.</>}
      >
        <Form name='new-password-form' className='auth-form pin-form login-pin' form={form} onFinish={onFinish}>
          <FloatingLabel label='New password (min 8 characters)' shortLabel='New password' name='password' inputValue={password}>
            <PasswordField name={'password'} setPassword={(value) => setPassword(value)} password={password} />
          </FloatingLabel>
          <FloatingLabel label='Retype password' name='confirm-password' inputValue={confirmPassword}>
            <PasswordField name={'newPassword'} setPassword={(value) => setConfirmPassword(value)} password={password} />
          </FloatingLabel>
          <Form.Item className='auth-form__fixed-submit' shouldUpdate>
            {() => (
              <Button
                htmlType='submit'
                type='primary'
                className='ant-btn-primary--alt'
                loading={loading}
                disabled={!form.isFieldsTouched(true) || form.getFieldsError().filter(({ errors }) => errors.length).length > 0}
              >
                Save password
              </Button>
            )}
          </Form.Item>
        </Form>
      </AuthForm>
    </div>
  );
};

export default NewPassword;
